// Event Details API types (/api/v1/events/{id}/)
import { EventStatusId } from 'routes/events/types/events.types';
import {
  EventType,
  PublicUser,
  EventParticipant,
  ParticipationCriteriaItem,
} from '../../../types/events/common.types';

export interface EventCondition {
  metric_key:
    | 'trade_volume_rmv'
    | 'trade_count'
    | 'fraction_count'
    | 'asset_nft_id_filter_count'
    | 'wallet_rmv_balance'
    | 'wallet_nft_count'
    | 'wallet_combined_worth'
    | 'referral_count'
    | 'referral_eligible_count'
    | 'referral_purchases';
  operator: 'gte' | 'gt' | 'lte' | 'lt' | 'eq';
  threshold: string;
}

export interface AssetSimple {
  id: number;
  name: string;
}

export interface EventAssetScope {
  asset: AssetSimple;
}

export interface EventTarget {
  target_metric: string;
  asset: {
    name: string;
    token_id: string;
    description: string;
    country_code: string | null;
  };
  threshold: string;
}

export interface AmaPrize {
  id: number;
  name: string;
  kind: string;
  distribution_type: string;
  token_currency: number;
  token_amount: string;
}

export interface AmaEvent {
  ama_link: string;
  requires_code_verification: boolean;
  code_valid_from: string | null;
  code_valid_to: string | null;
  ama_prize: AmaPrize;
}

export interface InformationalPrize {
  id: number;
  name: string;
  kind: string;
  icon_url: string | null;
  token_currency: Record<string, unknown> | null;
  token_amount: string | null;
  nft_asset: Record<string, unknown> | null;
  per_person_count: number | null;
}

export interface InformationalEvent {
  informational_link: string | null;
  has_registration: boolean;
  informational_prize: InformationalPrize | null;
}

export interface EventDetailApiResponse {
  id: number;
  name: string;
  event_type: EventType;
  event_label: 'vip' | null;
  tagline: string;
  description: string;
  event_target: EventTarget;
  rewards_distributed: boolean;
  reward_distribution_date: string;
  feature_highlights: any[];
  participation_criteria: ParticipationCriteriaItem[];
  image_url: string | null;
  banner_url: string | null;
  icon_url: string | null;
  visible: boolean;
  publication_date: string;
  start_datetime: string;
  end_datetime: string;
  status: EventStatusId;
  registration_start_datetime: string;
  registration_end_datetime: string;
  is_registration_open: boolean;
  list_mode: 'open' | 'whitelisted' | 'blacklisted';
  conditions: EventCondition[];
  asset_scope: EventAssetScope[];
  participants: EventParticipant[];
  participant_count: number;
  is_active: boolean;
  is_participating: boolean;
  ama_event: AmaEvent | null;
  informational_event: InformationalEvent | null;
}

export enum EventStatus {
  UPCOMING = 0,
  ONGOING = 1,
  FINISHED = 2,
  REWARDS_DISTRIBUTED = 3,
  REGISTRATION_OPEN = 4,
}
